(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalUserSearchItem', ['$compile', UserSearchItemDirective]);

    /* directive for user-search item in search-list */
    function UserSearchItemDirective($compile) {

        var directive = {
            restrict: 'A',
            templateUrl: '/app/global/templates/rf-global-user-search-item.template.html',
            scope: {
                user: '='
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            // add user image directive
            //var el = '<user-image user-id="user.id" class="flex-item-centered img-circle" style="flex-grow:0;" thumb-width="27" thumb-height="27"></user-image>';
            var container = element.find("#search_container");
                       

            // listen on user-change
            var watcher = scope.$watch(function () { return scope.user; }, function () {
                add();
            });

            // add image directive
            function add() {
                container.find("img").remove();
                //container.prepend($compile(el)(scope));
            } // add

            // destroy
            scope.$on("$destroy", function () {
                watcher();
                watcher = null;
            });

        } // link
    }

})();